export const RETENTION_LENGTH_OPTIONS = () => [30, 60, 90, 120, 150, 180, 210, 240, 270, 300, 330, 360];



// WEBPACK FOOTER //
// ./src/app/merchants/retention-settings/retention-settings.constants.js